import React, { useEffect, FC } from 'react';

import { useShopConfig } from 'src/explore/hooks/useShopConfig';
import { getCookie, setCookie } from 'src/prize/services/cookies';

import Modal from './organisms/Modal';

const VIEW = getCookie( 'first_order_promotion_view' );

const FirstOrderPromotion: FC = () => {
  const config = useShopConfig();

  useEffect(() => {
    if ( !VIEW ) {
      setCookie( 'first_order_promotion_view', new Date().getTime(), 0.5 );
    }
  }, []);

  if ( !!VIEW || !config.firstOrderPromotion.modal.enabled ) return null;

  return (
    <Modal
      discountInCents={config.firstOrderPromotion.discountInCents ?? 2000}
      logo={config.merchantLogo}
      merchant={config.merchantName}
    />
  );
};

export default FirstOrderPromotion;
